// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wt-auth-header.navbar-default {
  background: #fff;
  border-color: #e4eaf0;
  box-shadow: 0 1px 0 rgba(19, 45, 73, 0.06);
}

.wt-auth-header .container-fluid {
  position: relative;
  max-width: 1180px;
  padding-right: 24px;
  padding-left: 24px;
}

.wt-auth-header .navbar-header {
  float: none;
}

.wt-auth-header .navbar-brand {
  display: inline-flex;
  align-items: center;
  height: 58px;
  padding-top: 0;
  padding-bottom: 0;
  font-family: Georgia, 'Times New Roman', serif;
  font-size: 24px;
  letter-spacing: -0.35px;
}

.wt-auth-header .navbar-brand .navbar-logo {
  top: 12px;
  width: 34px;
  height: 34px;
}

.wt-auth-header .navbar-brand-label {
  margin-left: 42px;
}

.wt-auth-header-tools {
  position: absolute;
  top: 0;
  right: 24px;
  display: flex;
  align-items: center;
  height: 58px;
}

.wt-auth-header .wt-theme-toggle {
  min-height: 40px;
  padding: 10px 12px;
  border-radius: 8px;
}

.wt-auth-container {
  --wt-auth-ink: #101d32;
  --wt-auth-muted: #657184;
  --wt-auth-blue: #0872ce;
  --wt-auth-blue-dark: #075ca7;
  --wt-auth-teal: #147f86;
  --wt-auth-pale: #eef7fd;
  --wt-auth-border: #d9e2ec;
  width: 100%;
  padding: 48px 20px 64px;
}

.wt-auth-page {
  width: 100%;
  max-width: 620px;
  margin: 0 auto;
  color: var(--wt-auth-ink);
}

.wt-auth-card {
  padding: 38px 42px 36px;
  background: #fff;
  border: 1px solid var(--wt-auth-border);
  border-radius: 16px;
  box-shadow: 0 18px 52px rgba(36, 76, 119, 0.11);
}

.wt-auth-card-header {
  margin-bottom: 30px;
  text-align: center;
}

.wt-auth-card-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 66px;
  height: 66px;
  margin-bottom: 18px;
  color: var(--wt-auth-blue);
  background: var(--wt-auth-pale);
  border-radius: 50%;
  font-size: 28px;
}

.wt-auth-card-header h1 {
  margin: 0;
  color: var(--wt-auth-ink);
  font-family: Georgia, 'Times New Roman', serif;
  font-size: 40px;
  font-weight: 700;
  line-height: 1.15;
  letter-spacing: -0.9px;
}

.wt-auth-card-subtitle {
  max-width: 470px;
  margin: 12px auto 0;
  color: var(--wt-auth-muted);
  font-size: 17px;
  line-height: 1.55;
}

.wt-auth-progress {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin: -8px 0 24px;
  color: var(--wt-auth-blue-dark);
  font-size: 14px;
  font-weight: 700;
}

.wt-auth-progress::before,
.wt-auth-progress::after {
  width: 42px;
  height: 1px;
  content: '';
  background: #d9e7f3;
}

.wt-auth-card .form-group {
  margin-bottom: 18px;
}

.wt-auth-card .control-label {
  margin-bottom: 7px;
  color: var(--wt-auth-ink);
  font-size: 15px;
  font-weight: 700;
}

.wt-auth-card .form-control {
  height: 48px;
  padding: 11px 14px;
  color: var(--wt-auth-ink);
  background: #fff;
  border: 1px solid #cbd6e2;
  border-radius: 8px;
  box-shadow: none;
  font-size: 16px;
  line-height: 24px;
  transition: border-color 160ms ease, box-shadow 160ms ease;
}

.wt-auth-card .form-control:focus {
  border-color: var(--wt-auth-blue);
  box-shadow: 0 0 0 3px rgba(8, 114, 206, 0.13);
}

.wt-auth-card .btn-block {
  min-height: 48px;
  padding: 12px 18px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 650;
  line-height: 22px;
  transition: background-color 160ms ease, border-color 160ms ease, box-shadow 160ms ease, transform 160ms ease;
}

.wt-auth-card .btn-block:active {
  transform: translateY(1px);
}

.wt-auth-card .btn-primary,
.wt-auth-card .btn-info {
  color: #fff;
  background: var(--wt-auth-blue);
  border-color: var(--wt-auth-blue);
}

.wt-auth-card .btn-primary:hover,
.wt-auth-card .btn-primary:focus,
.wt-auth-card .btn-info:hover,
.wt-auth-card .btn-info:focus {
  color: #fff;
  background: var(--wt-auth-blue-dark);
  border-color: var(--wt-auth-blue-dark);
  box-shadow: 0 7px 18px rgba(7, 92, 167, 0.18);
}

.wt-auth-secondary-action.btn-default {
  color: var(--wt-auth-blue-dark);
  background: #fff;
  border: 1px solid var(--wt-auth-blue);
}

.wt-auth-secondary-action.btn-default:hover,
.wt-auth-secondary-action.btn-default:focus {
  color: var(--wt-auth-blue-dark);
  background: var(--wt-auth-pale);
  border-color: var(--wt-auth-blue-dark);
}

.wt-email-auth-panel-plain {
  margin: 0;
}

.wt-email-auth-panel-plain .wt-email-auth-body {
  padding: 0;
}

.wt-email-auth-panel-plain .alert {
  margin-bottom: 18px;
}

.wt-auth-method-copy {
  margin: -6px 0 20px;
  color: var(--wt-auth-muted);
  font-size: 15px;
  line-height: 1.5;
}

.wt-auth-method-stack {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 12px;
}

.wt-auth-method-stack .wt-passkey-option {
  margin: 0;
}

.wt-auth-tertiary-action {
  min-height: 44px;
  padding: 10px 12px;
  color: var(--wt-auth-blue-dark);
  background: transparent;
  border: 0;
  border-top: 1px solid #e4eaf0;
  border-bottom: 1px solid #e4eaf0;
  border-radius: 0;
  font-size: 15px;
}

.wt-auth-tertiary-action:hover,
.wt-auth-tertiary-action:focus {
  color: var(--wt-auth-blue-dark);
  background: #f7fbfe;
  text-decoration: none;
}

.wt-auth-session-option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  margin: 22px 0 0;
  padding-top: 18px;
  border-top: 1px solid #e4eaf0;
}

.wt-auth-session-option label {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
}

.wt-auth-session-option span {
  color: var(--wt-auth-muted);
  font-size: 13px;
  white-space: nowrap;
}

.wt-auth-method-header {
  margin-bottom: 22px;
}

.wt-auth-method-header h2 {
  margin: 0 0 7px;
  color: var(--wt-auth-ink);
  font-family: Georgia, 'Times New Roman', serif;
  font-size: 25px;
  font-weight: 700;
  line-height: 1.25;
  letter-spacing: -0.4px;
}

.wt-auth-method-header p {
  margin: 0;
  color: var(--wt-auth-muted);
  font-size: 15px;
  line-height: 1.5;
}

.wt-auth-method-back {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin: 0 0 18px;
  padding: 0;
  color: var(--wt-auth-blue-dark);
  background: transparent;
  border: 0;
  font-size: 14px;
}

.wt-auth-card .checkbox {
  margin: 18px 0;
}

.wt-auth-card .checkbox label {
  color: #26364c;
  font-size: 15px;
  line-height: 1.45;
}

.wt-auth-divider {
  display: flex;
  align-items: center;
  gap: 18px;
  margin: 24px 0 18px;
  color: #7b8797;
  font-size: 14px;
  text-transform: lowercase;
}

.wt-auth-divider::before,
.wt-auth-divider::after {
  flex: 1;
  height: 1px;
  content: '';
  background: #d7e0e9;
}

.wt-auth-page .wt-social-login > p {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.wt-auth-page .wt-social-login .btn-group {
  display: flex;
  width: 100%;
}

.wt-auth-page .wt-social-login .btn {
  flex: 1;
  min-height: 46px;
  padding: 11px 16px;
  color: #24364f;
  background: #fff;
  border-color: #cbd6e2;
  border-radius: 8px;
  font-size: 15px;
}

.wt-auth-page .wt-social-login .btn:hover,
.wt-auth-page .wt-social-login .btn:focus {
  color: var(--wt-auth-blue-dark);
  background: #f7fbfe;
  border-color: #9fb9d2;
}

.wt-auth-account-switch,
.wt-auth-utility-links {
  margin: 20px 0 0;
  color: var(--wt-auth-muted);
  text-align: center;
}

.wt-auth-account-switch a,
.wt-auth-utility-links a {
  color: var(--wt-auth-teal);
  font-weight: 600;
}

.wt-auth-utility-links {
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 14px;
}

.wt-auth-card .wt-login-flow-notice {
  margin: -10px 0 24px;
  background: #eef8fd;
  border-color: #8ccce6;
  border-radius: 8px;
}

.wt-auth-card .wt-password-signin-panel {
  padding: 22px 0 0;
}

.wt-auth-card .wt-login-help-links {
  font-size: 14px;
}

.wt-auth-card .wt-recovery-signin-panel {
  padding: 18px;
  background: #f6f9fc;
  border-color: var(--wt-auth-border);
  border-radius: 8px;
}

.wt-auth-options-loading {
  margin: 26px 0;
}

.wt-auth-footer {
  margin-top: 0;
  padding: 22px 20px;
  color: #728092;
  background: #f7f9fb;
  border-top: 1px solid #e3e9ef;
  font-size: 13px;
}

.wt-auth-footer-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  max-width: 620px;
  padding: 0;
  margin: 0 auto;
}

.wt-auth-footer-links {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 18px;
}

.wt-auth-footer a {
  color: #526376;
}

.wt-auth-footer .copyright {
  flex: 0 0 auto;
}

[data-theme='dark'] .wt-auth-header.navbar-default {
  background: #111820;
  border-color: #2d3945;
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.35);
}

[data-theme='dark'] .wt-auth-container {
  --wt-auth-ink: #edf3f8;
  --wt-auth-muted: #a8b5c3;
  --wt-auth-blue: #56a8ed;
  --wt-auth-blue-dark: #8ac7f4;
  --wt-auth-teal: #6ac7c8;
  --wt-auth-pale: #192c3b;
  --wt-auth-border: #364553;
}

[data-theme='dark'] .wt-auth-card {
  background: #171e26;
  box-shadow: 0 20px 58px rgba(0, 0, 0, 0.32);
}

[data-theme='dark'] .wt-auth-card .form-control {
  color: var(--wt-auth-ink);
  background: #10171f;
  border-color: #455565;
}

[data-theme='dark'] .wt-auth-card .form-control::placeholder {
  color: #82909f;
}

[data-theme='dark'] .wt-auth-secondary-action.btn-default,
[data-theme='dark'] .wt-auth-page .wt-social-login .btn {
  color: var(--wt-auth-blue-dark);
  background: #171e26;
  border-color: #4b6174;
}

[data-theme='dark'] .wt-auth-secondary-action.btn-default:hover,
[data-theme='dark'] .wt-auth-secondary-action.btn-default:focus,
[data-theme='dark'] .wt-auth-page .wt-social-login .btn:hover,
[data-theme='dark'] .wt-auth-page .wt-social-login .btn:focus,
[data-theme='dark'] .wt-auth-tertiary-action:hover,
[data-theme='dark'] .wt-auth-tertiary-action:focus {
  color: #b9dcf8;
  background: #202c37;
}

[data-theme='dark'] .wt-auth-tertiary-action,
[data-theme='dark'] .wt-auth-session-option {
  border-color: #33414e;
}

[data-theme='dark'] .wt-auth-card .checkbox label {
  color: #dce5ed;
}

[data-theme='dark'] .wt-auth-progress::before,
[data-theme='dark'] .wt-auth-progress::after,
[data-theme='dark'] .wt-auth-divider::before,
[data-theme='dark'] .wt-auth-divider::after {
  background: #3a4957;
}

[data-theme='dark'] .wt-auth-divider {
  color: var(--wt-auth-muted);
}

[data-theme='dark'] .wt-auth-card .wt-login-flow-notice {
  color: #d9eefb;
  background: #173244;
  border-color: #3f829e;
}

[data-theme='dark'] .wt-auth-card .wt-recovery-signin-panel {
  background: #131b23;
}

[data-theme='dark'] .wt-auth-footer {
  color: #94a3b2;
  background: #111820;
  border-color: #2d3945;
}

[data-theme='dark'] .wt-auth-footer a {
  color: #9cccf2;
}

@media (max-width: 767px) {
  .wt-auth-header .container-fluid {
    padding-right: 20px;
    padding-left: 20px;
  }

  .wt-auth-header-tools {
    right: 14px;
    height: 50px;
  }

  .wt-auth-header .wt-theme-toggle {
    min-width: 40px;
    padding: 10px;
  }

  .wt-auth-header .wt-theme-toggle-label {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }

  .wt-auth-header .navbar-brand {
    height: 50px;
    font-size: 21px;
  }

  .wt-auth-header .navbar-brand .navbar-logo {
    top: 9px;
    width: 32px;
    height: 32px;
  }

  .wt-auth-container {
    padding: 30px 20px 44px;
  }

  .wt-auth-card {
    padding: 30px 24px 28px;
    border-radius: 13px;
    box-shadow: 0 12px 34px rgba(36, 76, 119, 0.1);
  }

  .wt-auth-card-header {
    margin-bottom: 26px;
  }

  .wt-auth-card-icon {
    width: 58px;
    height: 58px;
    margin-bottom: 15px;
    font-size: 25px;
  }

  .wt-auth-card-header h1 {
    font-size: 34px;
    letter-spacing: -0.7px;
  }

  .wt-auth-card-subtitle {
    margin-top: 10px;
    font-size: 16px;
  }

  .wt-auth-session-option {
    align-items: flex-start;
    flex-direction: column;
    gap: 3px;
  }

  .wt-auth-session-option span {
    padding-left: 20px;
  }

  .wt-auth-method-header h2 {
    font-size: 23px;
  }

  .wt-auth-footer-inner {
    align-items: center;
    flex-direction: column;
    gap: 12px;
    text-align: center;
  }

  .wt-auth-footer-links {
    justify-content: center;
  }
}

@media (max-width: 413px) {
  .wt-auth-container {
    padding-right: 14px;
    padding-left: 14px;
  }

  .wt-auth-card {
    padding-right: 20px;
    padding-left: 20px;
  }

  .wt-auth-card-header h1 {
    font-size: 31px;
  }

  .wt-auth-card-subtitle {
    font-size: 15px;
  }

  .wt-auth-page .wt-social-login .btn {
    font-size: 14px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .wt-auth-card .btn-block,
  .wt-auth-card .form-control {
    transition: none;
  }
}
`, "",{"version":3,"sources":["webpack://./client/src/styles/auth.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,8CAA8C;EAC9C,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,uBAAuB;EACvB,4BAA4B;EAC5B,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;EACzB,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,uCAAuC;EACvC,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;EAC1B,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,yBAAyB;EACzB,8CAA8C;EAC9C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,WAAW;EACX,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,0DAA0D;AAC5D;;AAEA;EACE,iCAAiC;EACjC,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,6GAA6G;AAC/G;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,WAAW;EACX,+BAA+B;EAC/B,iCAAiC;AACnC;;AAEA;;;;EAIE,WAAW;EACX,oCAAoC;EACpC,sCAAsC;EACtC,6CAA6C;AAC/C;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;;EAEE,+BAA+B;EAC/B,+BAA+B;EAC/B,sCAAsC;AACxC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;EAC/B,uBAAuB;EACvB,SAAS;EACT,6BAA6B;EAC7B,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,+BAA+B;EAC/B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,8CAA8C;EAC9C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,UAAU;EACV,+BAA+B;EAC/B,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;;EAEE,OAAO;EACP,WAAW;EACX,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,+BAA+B;EAC/B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;;EAEE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,uCAAuC;AACzC;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,uBAAuB;EACvB,4BAA4B;EAC5B,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,+BAA+B;EAC/B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;;;;;EAME,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;EAIE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;IACf,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,QAAQ;IACR,WAAW;IACX,YAAY;EACd;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;IACnB,8CAA8C;EAChD;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;;IAEE,gBAAgB;EAClB;AACF","sourcesContent":[".wt-auth-header.navbar-default {\n  background: #fff;\n  border-color: #e4eaf0;\n  box-shadow: 0 1px 0 rgba(19, 45, 73, 0.06);\n}\n\n.wt-auth-header .container-fluid {\n  position: relative;\n  max-width: 1180px;\n  padding-right: 24px;\n  padding-left: 24px;\n}\n\n.wt-auth-header .navbar-header {\n  float: none;\n}\n\n.wt-auth-header .navbar-brand {\n  display: inline-flex;\n  align-items: center;\n  height: 58px;\n  padding-top: 0;\n  padding-bottom: 0;\n  font-family: Georgia, 'Times New Roman', serif;\n  font-size: 24px;\n  letter-spacing: -0.35px;\n}\n\n.wt-auth-header .navbar-brand .navbar-logo {\n  top: 12px;\n  width: 34px;\n  height: 34px;\n}\n\n.wt-auth-header .navbar-brand-label {\n  margin-left: 42px;\n}\n\n.wt-auth-header-tools {\n  position: absolute;\n  top: 0;\n  right: 24px;\n  display: flex;\n  align-items: center;\n  height: 58px;\n}\n\n.wt-auth-header .wt-theme-toggle {\n  min-height: 40px;\n  padding: 10px 12px;\n  border-radius: 8px;\n}\n\n.wt-auth-container {\n  --wt-auth-ink: #101d32;\n  --wt-auth-muted: #657184;\n  --wt-auth-blue: #0872ce;\n  --wt-auth-blue-dark: #075ca7;\n  --wt-auth-teal: #147f86;\n  --wt-auth-pale: #eef7fd;\n  --wt-auth-border: #d9e2ec;\n  width: 100%;\n  padding: 48px 20px 64px;\n}\n\n.wt-auth-page {\n  width: 100%;\n  max-width: 620px;\n  margin: 0 auto;\n  color: var(--wt-auth-ink);\n}\n\n.wt-auth-card {\n  padding: 38px 42px 36px;\n  background: #fff;\n  border: 1px solid var(--wt-auth-border);\n  border-radius: 16px;\n  box-shadow: 0 18px 52px rgba(36, 76, 119, 0.11);\n}\n\n.wt-auth-card-header {\n  margin-bottom: 30px;\n  text-align: center;\n}\n\n.wt-auth-card-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 66px;\n  height: 66px;\n  margin-bottom: 18px;\n  color: var(--wt-auth-blue);\n  background: var(--wt-auth-pale);\n  border-radius: 50%;\n  font-size: 28px;\n}\n\n.wt-auth-card-header h1 {\n  margin: 0;\n  color: var(--wt-auth-ink);\n  font-family: Georgia, 'Times New Roman', serif;\n  font-size: 40px;\n  font-weight: 700;\n  line-height: 1.15;\n  letter-spacing: -0.9px;\n}\n\n.wt-auth-card-subtitle {\n  max-width: 470px;\n  margin: 12px auto 0;\n  color: var(--wt-auth-muted);\n  font-size: 17px;\n  line-height: 1.55;\n}\n\n.wt-auth-progress {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  margin: -8px 0 24px;\n  color: var(--wt-auth-blue-dark);\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.wt-auth-progress::before,\n.wt-auth-progress::after {\n  width: 42px;\n  height: 1px;\n  content: '';\n  background: #d9e7f3;\n}\n\n.wt-auth-card .form-group {\n  margin-bottom: 18px;\n}\n\n.wt-auth-card .control-label {\n  margin-bottom: 7px;\n  color: var(--wt-auth-ink);\n  font-size: 15px;\n  font-weight: 700;\n}\n\n.wt-auth-card .form-control {\n  height: 48px;\n  padding: 11px 14px;\n  color: var(--wt-auth-ink);\n  background: #fff;\n  border: 1px solid #cbd6e2;\n  border-radius: 8px;\n  box-shadow: none;\n  font-size: 16px;\n  line-height: 24px;\n  transition: border-color 160ms ease, box-shadow 160ms ease;\n}\n\n.wt-auth-card .form-control:focus {\n  border-color: var(--wt-auth-blue);\n  box-shadow: 0 0 0 3px rgba(8, 114, 206, 0.13);\n}\n\n.wt-auth-card .btn-block {\n  min-height: 48px;\n  padding: 12px 18px;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 650;\n  line-height: 22px;\n  transition: background-color 160ms ease, border-color 160ms ease, box-shadow 160ms ease, transform 160ms ease;\n}\n\n.wt-auth-card .btn-block:active {\n  transform: translateY(1px);\n}\n\n.wt-auth-card .btn-primary,\n.wt-auth-card .btn-info {\n  color: #fff;\n  background: var(--wt-auth-blue);\n  border-color: var(--wt-auth-blue);\n}\n\n.wt-auth-card .btn-primary:hover,\n.wt-auth-card .btn-primary:focus,\n.wt-auth-card .btn-info:hover,\n.wt-auth-card .btn-info:focus {\n  color: #fff;\n  background: var(--wt-auth-blue-dark);\n  border-color: var(--wt-auth-blue-dark);\n  box-shadow: 0 7px 18px rgba(7, 92, 167, 0.18);\n}\n\n.wt-auth-secondary-action.btn-default {\n  color: var(--wt-auth-blue-dark);\n  background: #fff;\n  border: 1px solid var(--wt-auth-blue);\n}\n\n.wt-auth-secondary-action.btn-default:hover,\n.wt-auth-secondary-action.btn-default:focus {\n  color: var(--wt-auth-blue-dark);\n  background: var(--wt-auth-pale);\n  border-color: var(--wt-auth-blue-dark);\n}\n\n.wt-email-auth-panel-plain {\n  margin: 0;\n}\n\n.wt-email-auth-panel-plain .wt-email-auth-body {\n  padding: 0;\n}\n\n.wt-email-auth-panel-plain .alert {\n  margin-bottom: 18px;\n}\n\n.wt-auth-method-copy {\n  margin: -6px 0 20px;\n  color: var(--wt-auth-muted);\n  font-size: 15px;\n  line-height: 1.5;\n}\n\n.wt-auth-method-stack {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-top: 12px;\n}\n\n.wt-auth-method-stack .wt-passkey-option {\n  margin: 0;\n}\n\n.wt-auth-tertiary-action {\n  min-height: 44px;\n  padding: 10px 12px;\n  color: var(--wt-auth-blue-dark);\n  background: transparent;\n  border: 0;\n  border-top: 1px solid #e4eaf0;\n  border-bottom: 1px solid #e4eaf0;\n  border-radius: 0;\n  font-size: 15px;\n}\n\n.wt-auth-tertiary-action:hover,\n.wt-auth-tertiary-action:focus {\n  color: var(--wt-auth-blue-dark);\n  background: #f7fbfe;\n  text-decoration: none;\n}\n\n.wt-auth-session-option {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 14px;\n  margin: 22px 0 0;\n  padding-top: 18px;\n  border-top: 1px solid #e4eaf0;\n}\n\n.wt-auth-session-option label {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 600;\n}\n\n.wt-auth-session-option span {\n  color: var(--wt-auth-muted);\n  font-size: 13px;\n  white-space: nowrap;\n}\n\n.wt-auth-method-header {\n  margin-bottom: 22px;\n}\n\n.wt-auth-method-header h2 {\n  margin: 0 0 7px;\n  color: var(--wt-auth-ink);\n  font-family: Georgia, 'Times New Roman', serif;\n  font-size: 25px;\n  font-weight: 700;\n  line-height: 1.25;\n  letter-spacing: -0.4px;\n}\n\n.wt-auth-method-header p {\n  margin: 0;\n  color: var(--wt-auth-muted);\n  font-size: 15px;\n  line-height: 1.5;\n}\n\n.wt-auth-method-back {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin: 0 0 18px;\n  padding: 0;\n  color: var(--wt-auth-blue-dark);\n  background: transparent;\n  border: 0;\n  font-size: 14px;\n}\n\n.wt-auth-card .checkbox {\n  margin: 18px 0;\n}\n\n.wt-auth-card .checkbox label {\n  color: #26364c;\n  font-size: 15px;\n  line-height: 1.45;\n}\n\n.wt-auth-divider {\n  display: flex;\n  align-items: center;\n  gap: 18px;\n  margin: 24px 0 18px;\n  color: #7b8797;\n  font-size: 14px;\n  text-transform: lowercase;\n}\n\n.wt-auth-divider::before,\n.wt-auth-divider::after {\n  flex: 1;\n  height: 1px;\n  content: '';\n  background: #d7e0e9;\n}\n\n.wt-auth-page .wt-social-login > p {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n.wt-auth-page .wt-social-login .btn-group {\n  display: flex;\n  width: 100%;\n}\n\n.wt-auth-page .wt-social-login .btn {\n  flex: 1;\n  min-height: 46px;\n  padding: 11px 16px;\n  color: #24364f;\n  background: #fff;\n  border-color: #cbd6e2;\n  border-radius: 8px;\n  font-size: 15px;\n}\n\n.wt-auth-page .wt-social-login .btn:hover,\n.wt-auth-page .wt-social-login .btn:focus {\n  color: var(--wt-auth-blue-dark);\n  background: #f7fbfe;\n  border-color: #9fb9d2;\n}\n\n.wt-auth-account-switch,\n.wt-auth-utility-links {\n  margin: 20px 0 0;\n  color: var(--wt-auth-muted);\n  text-align: center;\n}\n\n.wt-auth-account-switch a,\n.wt-auth-utility-links a {\n  color: var(--wt-auth-teal);\n  font-weight: 600;\n}\n\n.wt-auth-utility-links {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  font-size: 14px;\n}\n\n.wt-auth-card .wt-login-flow-notice {\n  margin: -10px 0 24px;\n  background: #eef8fd;\n  border-color: #8ccce6;\n  border-radius: 8px;\n}\n\n.wt-auth-card .wt-password-signin-panel {\n  padding: 22px 0 0;\n}\n\n.wt-auth-card .wt-login-help-links {\n  font-size: 14px;\n}\n\n.wt-auth-card .wt-recovery-signin-panel {\n  padding: 18px;\n  background: #f6f9fc;\n  border-color: var(--wt-auth-border);\n  border-radius: 8px;\n}\n\n.wt-auth-options-loading {\n  margin: 26px 0;\n}\n\n.wt-auth-footer {\n  margin-top: 0;\n  padding: 22px 20px;\n  color: #728092;\n  background: #f7f9fb;\n  border-top: 1px solid #e3e9ef;\n  font-size: 13px;\n}\n\n.wt-auth-footer-inner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 18px;\n  max-width: 620px;\n  padding: 0;\n  margin: 0 auto;\n}\n\n.wt-auth-footer-links {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px 18px;\n}\n\n.wt-auth-footer a {\n  color: #526376;\n}\n\n.wt-auth-footer .copyright {\n  flex: 0 0 auto;\n}\n\n[data-theme='dark'] .wt-auth-header.navbar-default {\n  background: #111820;\n  border-color: #2d3945;\n  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.35);\n}\n\n[data-theme='dark'] .wt-auth-container {\n  --wt-auth-ink: #edf3f8;\n  --wt-auth-muted: #a8b5c3;\n  --wt-auth-blue: #56a8ed;\n  --wt-auth-blue-dark: #8ac7f4;\n  --wt-auth-teal: #6ac7c8;\n  --wt-auth-pale: #192c3b;\n  --wt-auth-border: #364553;\n}\n\n[data-theme='dark'] .wt-auth-card {\n  background: #171e26;\n  box-shadow: 0 20px 58px rgba(0, 0, 0, 0.32);\n}\n\n[data-theme='dark'] .wt-auth-card .form-control {\n  color: var(--wt-auth-ink);\n  background: #10171f;\n  border-color: #455565;\n}\n\n[data-theme='dark'] .wt-auth-card .form-control::placeholder {\n  color: #82909f;\n}\n\n[data-theme='dark'] .wt-auth-secondary-action.btn-default,\n[data-theme='dark'] .wt-auth-page .wt-social-login .btn {\n  color: var(--wt-auth-blue-dark);\n  background: #171e26;\n  border-color: #4b6174;\n}\n\n[data-theme='dark'] .wt-auth-secondary-action.btn-default:hover,\n[data-theme='dark'] .wt-auth-secondary-action.btn-default:focus,\n[data-theme='dark'] .wt-auth-page .wt-social-login .btn:hover,\n[data-theme='dark'] .wt-auth-page .wt-social-login .btn:focus,\n[data-theme='dark'] .wt-auth-tertiary-action:hover,\n[data-theme='dark'] .wt-auth-tertiary-action:focus {\n  color: #b9dcf8;\n  background: #202c37;\n}\n\n[data-theme='dark'] .wt-auth-tertiary-action,\n[data-theme='dark'] .wt-auth-session-option {\n  border-color: #33414e;\n}\n\n[data-theme='dark'] .wt-auth-card .checkbox label {\n  color: #dce5ed;\n}\n\n[data-theme='dark'] .wt-auth-progress::before,\n[data-theme='dark'] .wt-auth-progress::after,\n[data-theme='dark'] .wt-auth-divider::before,\n[data-theme='dark'] .wt-auth-divider::after {\n  background: #3a4957;\n}\n\n[data-theme='dark'] .wt-auth-divider {\n  color: var(--wt-auth-muted);\n}\n\n[data-theme='dark'] .wt-auth-card .wt-login-flow-notice {\n  color: #d9eefb;\n  background: #173244;\n  border-color: #3f829e;\n}\n\n[data-theme='dark'] .wt-auth-card .wt-recovery-signin-panel {\n  background: #131b23;\n}\n\n[data-theme='dark'] .wt-auth-footer {\n  color: #94a3b2;\n  background: #111820;\n  border-color: #2d3945;\n}\n\n[data-theme='dark'] .wt-auth-footer a {\n  color: #9cccf2;\n}\n\n@media (max-width: 767px) {\n  .wt-auth-header .container-fluid {\n    padding-right: 20px;\n    padding-left: 20px;\n  }\n\n  .wt-auth-header-tools {\n    right: 14px;\n    height: 50px;\n  }\n\n  .wt-auth-header .wt-theme-toggle {\n    min-width: 40px;\n    padding: 10px;\n  }\n\n  .wt-auth-header .wt-theme-toggle-label {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    padding: 0;\n    margin: -1px;\n    overflow: hidden;\n    clip: rect(0, 0, 0, 0);\n    white-space: nowrap;\n    border: 0;\n  }\n\n  .wt-auth-header .navbar-brand {\n    height: 50px;\n    font-size: 21px;\n  }\n\n  .wt-auth-header .navbar-brand .navbar-logo {\n    top: 9px;\n    width: 32px;\n    height: 32px;\n  }\n\n  .wt-auth-container {\n    padding: 30px 20px 44px;\n  }\n\n  .wt-auth-card {\n    padding: 30px 24px 28px;\n    border-radius: 13px;\n    box-shadow: 0 12px 34px rgba(36, 76, 119, 0.1);\n  }\n\n  .wt-auth-card-header {\n    margin-bottom: 26px;\n  }\n\n  .wt-auth-card-icon {\n    width: 58px;\n    height: 58px;\n    margin-bottom: 15px;\n    font-size: 25px;\n  }\n\n  .wt-auth-card-header h1 {\n    font-size: 34px;\n    letter-spacing: -0.7px;\n  }\n\n  .wt-auth-card-subtitle {\n    margin-top: 10px;\n    font-size: 16px;\n  }\n\n  .wt-auth-session-option {\n    align-items: flex-start;\n    flex-direction: column;\n    gap: 3px;\n  }\n\n  .wt-auth-session-option span {\n    padding-left: 20px;\n  }\n\n  .wt-auth-method-header h2 {\n    font-size: 23px;\n  }\n\n  .wt-auth-footer-inner {\n    align-items: center;\n    flex-direction: column;\n    gap: 12px;\n    text-align: center;\n  }\n\n  .wt-auth-footer-links {\n    justify-content: center;\n  }\n}\n\n@media (max-width: 413px) {\n  .wt-auth-container {\n    padding-right: 14px;\n    padding-left: 14px;\n  }\n\n  .wt-auth-card {\n    padding-right: 20px;\n    padding-left: 20px;\n  }\n\n  .wt-auth-card-header h1 {\n    font-size: 31px;\n  }\n\n  .wt-auth-card-subtitle {\n    font-size: 15px;\n  }\n\n  .wt-auth-page .wt-social-login .btn {\n    font-size: 14px;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .wt-auth-card .btn-block,\n  .wt-auth-card .form-control {\n    transition: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
